<template>
           <div class="widget widget--border-box cat-trending single-cat">
                            <div class="widget__title has-ajax-load" v-bind:style="{borderLeft: '3px solid ' + categoryBorderColor}">
                                <h4>{{ mostRecent? "Najnovije" : "Najčitanije" }}</h4>
                                <div class="ajax-load-btns">
                                    <button class="prev" v-on:click="next()"><i class="fa fa-angle-right"></i></button>
                                    <button class="next" v-on:click="previous()"><i class="fa fa-angle-left"></i></button>
                                    <button class="toggleNews" v-on:click="toggleNews()">{{ mostRecent? "Najčitanije" : "Najnovije" }}</button>
                                </div>
                            </div>
                            <ul class="posts-wrap">
                              <v-bar v-if="posts.length > 0" wrapper="wrapper">
                                <li v-for="(post, i) in posts" :key="i">
                                    <figure v-bind:style="{borderLeft: '2px solid ' + post.postCategoryBorderColor}">
                                        <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}"><img v-lazy="post.absoluteThumbUrl" v-bind:alt="post.title"></router-link>
                                    </figure>
                                    <div class="post-content">
                                        <h6 class="post-title">
                                            <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}">
                                                {{ post.shortTitle != null? post.shortTitle : post.title }}
                                            </router-link>
                                        </h6>
                                        <div class="post-meta">
                                           <time><i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }} </time>
                                        </div>
                                    </div>
                                </li>
                              </v-bar>
                            </ul>
                        </div>
</template>

<script>
    import { NewsService } from '../common/api.service'
    import VBar from 'v-bar'

    export default {
        name: "MostRecent",
        components: { VBar },
        props: ['postCategoryId','postSubcategoryId', 'postCategoryBorderColor', 'takeCount'],
        data() {
            return {
                posts: [],
                skip: 0,
                take: this.takeCount? this.takeCount : 5,
                categoryId: this.postCategoryId,
                subcategoryId: this.postSubcategoryId,
                categoryBorderColor: this.postCategoryBorderColor,
                mostRecent: true
            }
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData: function() {   
                if(this.mostRecent) {
                    NewsService.getMostRecent(this.categoryId? this.categoryId : null, this.subcategoryId? this.subcategoryId : null, this.skip, this.take)
                           .then(res => {
                               this.posts = res.data; 
                            });
                }
                else {
                    NewsService.getMostRead(this.categoryId? this.categoryId : null, this.subcategoryId? this.subcategoryId : null, this.skip, this.take)
                           .then(res => {
                               this.posts = res.data; 
                            });
                }

            },
            next: function() {
                if(this.skip != 0)
                    this.skip -= this.take;
                this.fetchData();
            },
            previous: function() {
                    this.skip += this.take;
                this.fetchData();
            },
            toggleNews: function() {
                this.mostRecent = !this.mostRecent;
                this.skip = 0;
                this.fetchData();
            }
        }
     }
</script>

<style scoped>
    .toggleNews {
        right: 95px;
        bottom: 10px;
        width: auto;
        font-size: 15px;
        color: #958d8d;
    }

    .wrapper {
        height: 668.6px;
    }

    .widget--border-box.single-cat .posts-wrap li {
        margin-bottom: 5px;
    }

    .ad-300-250-sidebar-above {
        text-align: center;
        margin-bottom: 40px;
    }

    .ad-300-250-sidebar-below {
        text-align: center;
        margin-top: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/MostRecent.vue